import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const teamMembers = [{
  name: "Ing. Roberto Kalisch",
  role: "Director General",
  bio: "Con más de 25 años liderando la industria del acero, Roberto ha consolidado a Kalisch Acero como un referente de innovación y compromiso con la calidad en todo México.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/liderazgo_roberto_kalisch.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/liderazgo_roberto_kalisch.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/liderazgo_roberto_kalisch.png-wvc-sizes",
    alt: "Retrato de Roberto Kalisch, Director General"
  }
}, {
  name: "Lic. Elena Martínez",
  role: "Directora de Operaciones",
  bio: "Especialista en optimización de procesos industriales y logística. Elena asegura que nuestra cadena de suministro cumpla con los más altos estándares de eficiencia y seguridad.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/operaciones_elena_martinez.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/operaciones_elena_martinez.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/operaciones_elena_martinez.png-wvc-sizes",
    alt: "Retrato de Elena Martínez, Directora de Operaciones"
  }
}, {
  name: "Ing. Carlos Méndez",
  role: "Gerente de Planta Senior",
  bio: "Experto en metalurgia y procesos de fundición. Carlos supervisa la producción técnica, garantizando que cada tonelada de acero cumpla con las especificaciones internacionales.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/planta_carlos_mendez.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/planta_carlos_mendez.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/planta_carlos_mendez.png-wvc-sizes",
    alt: "Retrato de Carlos Méndez, Gerente de Planta"
  }
}, {
  name: "Dra. Sofía Vega",
  role: "Líder de Sostenibilidad",
  bio: "Responsable de nuestras iniciativas de economía circular. Sofía dirige los programas de reciclaje y reducción de huella de carbono en todas nuestras divisiones operativas.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/sostenibilidad_sofia_vega.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/sostenibilidad_sofia_vega.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/sostenibilidad_sofia_vega.png-wvc-sizes",
    alt: "Retrato de Sofía Vega, Líder de Sostenibilidad"
  }
}];
export default function Talent() {
  return <section data-section-id="262974" id="talent" className="w-full py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className="text-3xl md:text-5xl font-bold font-default text-foreground mb-4 tracking-tight">
            Nuestro Talento Humano
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto font-default">
            Contamos con un equipo de expertos comprometidos con la excelencia industrial y el desarrollo sostenible de la industria del acero.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {teamMembers.map((member, i) => <Card key={i} data-index={i} className="overflow-hidden border border-border shadow-md flex flex-col h-full transition-all hover:shadow-lg hover:border-primary/20 rounded-lg">
              <div className="w-full bg-muted">
                <AspectRatio ratio={1}>
                  <img src={member.image.src} data-wvc-srcset={member.image.srcset} data-wvc-sizes={member.image.sizes} alt={member.image.alt} className="object-cover w-full h-full grayscale hover:grayscale-0 transition-all duration-500" loading="lazy" />
                </AspectRatio>
              </div>
              <CardHeader className="p-6 pb-3 flex-none">
                <CardTitle className="text-xl font-bold font-default text-foreground">
                  {member.name}
                </CardTitle>
                <p className="text-sm font-semibold text-primary uppercase tracking-wider mt-1 font-default">
                  {member.role}
                </p>
              </CardHeader>
              <CardContent className="p-6 pt-0 flex-grow">
                <p className="text-sm text-muted-foreground leading-relaxed font-default">
                  {member.bio}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}